module.exports = __webpack_public_path__ + "img/calles.4af3b6c7.png";